/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import CardActions from '@material-ui/core/CardActions';
import { Auth, I18n, Logger } from 'aws-amplify';
import React from 'react';
import AmplifyTheme from '../AmplifyTheme';
import { ButtonRow, FormSection, MessageRow, InputRow, Link, SectionBody, SectionFooter } from '../AmplifyUI';
import AuthPiece from './AuthPiece';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { logEvent } from "firebase/analytics";
import { analytics } from "../../api/firebase";


const logger = new Logger('ForgotPassword');

export default class ForgotPassword extends AuthPiece {
    constructor(props) {
        super(props);

        this.send = this.send.bind(this);
        this.submit = this.submit.bind(this);

        this._validAuthStates = ['forgotPassword'];
        this.state = { delivery: null,resendmsg : [] };

        logEvent(analytics, 'hcp_public_user_navigated', {
            page_name: 'forgot_password_page',
            datetime: new Date().toISOString(),
        });
    }

    cleanUsername(raw) {
        // Cognito's InitiateAuth rejects control/zero-width/bidi chars (regex [\p{L}\p{M}\p{S}\p{N}\p{P}]+); strip them and trim before sending.
        return (raw || '')
            .replace(/[\u0000-\u001F\u007F-\u009F\u200B-\u200F\uFEFF]/g, '')
            .trim();
    }

    send() {
        const username = this.cleanUsername(this.inputs.username);
        if (!username) {
            this.error('Please enter username');
            return;
        }
        if (!/^[0-9a-zA-Z]{6,12}$/.test(username)) {
            this.error('Invalid Username. Please use your CPR Number or Passport No (6-12 letters/digits, no spaces).');
            return;
        }
        Auth.forgotPassword(username)
            .then(data => {
                logger.debug(data)
                this.setState({ delivery: data.CodeDeliveryDetails ,resendmsg: data.CodeDeliveryDetails});
            })
            .catch(err => this.error(err));
    }

    submit() {
        const username = this.cleanUsername(this.inputs.username);
        const { code, password } = this.inputs;
        Auth.forgotPasswordSubmit(username, code, password)
            .then(data => {
                logger.debug(data);
                this.changeState('signIn');
                this.setState({ delivery: null,resendmsg:[] });
            })
            .catch(err => this.error(err));
    }

    sendView() {
        const theme = this.props.theme || AmplifyTheme;
        return (
            <div className="text-center">

                <InputRow
                    autoFocus
                    placeholder={I18n.get('Username/CPR')}
                    theme={theme}
                    key="username"
                    name="username"
                    onChange={this.handleInputChange}
                />
                <SectionBody >
                    <ButtonRow theme={theme} onClick={this.send}>
                        {I18n.get('Send Code')}
                    </ButtonRow>
                </SectionBody >
            </div>
        )
    }

    submitView() {
        const theme = this.props.theme || AmplifyTheme;
        return (
            <div className="text-center">
                <InputRow
                    placeholder={I18n.get('Code')}
                    theme={theme}
                    key="code"
                    name="code"
                    onChange={this.handleInputChange}
                />
                <InputRow
                    placeholder={I18n.get('New Password')}
                    theme={theme}
                    type="password"
                    key="password"
                    name="password"
                    onChange={this.handleInputChange}
                />
                <ButtonRow theme={theme} onClick={this.submit}>
                    {I18n.get('Submit')}
                </ButtonRow>
            </div>
        )
    }

    showComponent(theme) {
        const { authState, hide } = this.props;
        if (hide && hide.includes(ForgotPassword)) { return null; }

        return (
            <div className="flex_div">
            <div className="login-content text-center" >
            <div className="logo_main">
                        <img src="/Mehan_logo.png" />
                    </div>
                <div className="logo-text">NATIONAL HEALTH REGULATORY AUTHORITY</div>
                <div className="mt-3">
                    <h2 className="text-center">{I18n.get('Forgot Password')}</h2>
                </div>
                <FormSection theme={theme}>

                    <Grid container spacing={16}>
                        <Grid item xs={12} className ="fontInfo">
                            <MessageRow>
                            {this.state.delivery &&  this.state.delivery.AttributeName == 'email' && <b>{'Check your mail!'}</b>} 
                            {this.state.delivery &&  this.state.delivery.AttributeName == 'phone_number' && <b>{'Check your mobile!'}</b>} <br />
                            {this.state.delivery &&  'Enter the code sent to ' + this.state.delivery.Destination} 
                            </MessageRow>  
                        </Grid>
                    </Grid>

                    <SectionBody >
                        {this.state.delivery ? this.submitView() : this.sendView()}
                    </SectionBody>
                    <div>&nbsp;</div>

                    <Grid container spacing={16}>
                        <Grid item xs={12} className ="fontInfo">
                            <MessageRow>
                            {this.state.delivery ?'Verification code sent to your registered email/sms.':'Verification code will be sent to your registered email/sms.'}
                           
                            </MessageRow>  
                        </Grid>
                        <Grid item xs={12}>
                            <hr />
                            <Button
                                color="secondary"
                                onClick={() => this.changeState('signIn')}>
                                {I18n.get('Back to Sign In')}
                            </Button>
                        </Grid>
                    </Grid>
                </FormSection>
                <CardActions>
                </CardActions>
            </div>
            </div>
        )
    }
}
